import PropTypes from 'prop-types';
import React from 'react';
import ReactPaginate from 'react-paginate';

import { nextLabel, previousLabel } from './PaginationLabelsIcons';

import styles from './ReportPagination.module.scss';

export function ReportPaginationControls({ pageCount, onPageChange, currentPage }) {
  return (
    <div>
      <ReactPaginate
        previousLabel={previousLabel}
        previousClassName={styles.previous}
        nextLabel={nextLabel}
        nextClassName={styles.next}
        pageCount={pageCount}
        marginPagesDisplayed={2}
        onPageChange={onPageChange}
        containerClassName={styles.reportPaginationControlsWrapper}
        activeClassName={styles.active}
        forcePage={currentPage}
        renderOnZeroPageCount={null}
      />
    </div>
  );
}

ReportPaginationControls.propTypes = {
  currentPage: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  pageCount: PropTypes.number.isRequired,
};
